import { useTranslation } from "react-i18next";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import CustomDialog from "../modals/CustomDialog/CustomDialog";
import { Button } from "../forms/Buttons/Button";

export default function SubmitConfirmModal({
  isOpen,
  onConfirm,
  onCancel,
  totalQuestions,
  answeredQuestions,
  loading = false,
}) {
  const { t } = useTranslation();
  const unanswered = totalQuestions - answeredQuestions;

  return (
    <CustomDialog
      isOpen={isOpen}
      headerText={t("exam_taking.submit_exam")}
      closeModal={onCancel}
      maxWidth="max-w-lg"
    >
      <div className="flex flex-col gap-6 pt-4">
        <div className="flex items-start gap-4">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-amber-50 ring-1 ring-inset ring-amber-100">
            <ExclamationTriangleIcon className="h-5 w-5 text-amber-600" aria-hidden="true" />
          </span>
          <div className="min-w-0 pt-0.5">
            <p className="font-medium text-slate-900">
              {t("exam_taking.confirm_submit")}
            </p>
            {unanswered > 0 && (
              <p className="mt-2 inline-flex rounded-lg bg-amber-50 px-3 py-2 text-sm font-medium text-amber-800 ring-1 ring-inset ring-amber-200">
                {t("exam_taking.unanswered_warning", {
                  answered: answeredQuestions,
                  total: totalQuestions,
                })}
              </p>
            )}
          </div>
        </div>

        <div className="flex flex-col-reverse gap-3 border-t border-slate-100 pt-5 sm:flex-row sm:justify-end">
          <Button
            text={t("buttons.cancel")}
            color="secondary-outline"
            onClick={onCancel}
            disabled={loading}
          />
          <Button
            text={t("exam_taking.submit_exam")}
            color="primary"
            onClick={onConfirm}
            loading={loading}
          />
        </div>
      </div>
    </CustomDialog>
  );
}
